import { useState } from 'react';
import { useTheme } from '@mui/material';
import DSBox from '../../../design-system/DSBox';
import { DSTypography } from '../../../design-system/Typography';
import DSMenu from '../../../design-system/DSMenu';
import DSMenuItem from '../../../design-system/DSMenuItem';
import { ArrowDropDown } from '@mui/icons-material';
import { OrderGraphPeriod } from '../../../api/collections';

export type PeriodSelectorProps = {
  selectedPeriod: OrderGraphPeriod;
  onPeriodChange: (period: OrderGraphPeriod) => void;
  periodLabels: Record<OrderGraphPeriod, string>;
};

const PeriodSelector = ({
  selectedPeriod,
  onPeriodChange,
  periodLabels,
}: PeriodSelectorProps) => {
  const { spacing } = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePeriodSelect = (period: OrderGraphPeriod) => {
    onPeriodChange(period);
    handleMenuClose();
  };

  return (
    <>
      <DSBox
        onClick={handleMenuOpen}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.08)',
          borderRadius: spacing(1),
          padding: spacing(1, 2),
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
          },
        }}
      >
        <DSTypography variant="body1">
          {periodLabels[selectedPeriod]}
        </DSTypography>
        <ArrowDropDown />
      </DSBox>
      <DSMenu anchorEl={anchorEl} open={menuOpen} onClose={handleMenuClose}>
        <DSMenuItem onClick={() => handlePeriodSelect(OrderGraphPeriod.DAY)}>
          Day
        </DSMenuItem>
        <DSMenuItem onClick={() => handlePeriodSelect(OrderGraphPeriod.WEEK)}>
          Week
        </DSMenuItem>
        <DSMenuItem onClick={() => handlePeriodSelect(OrderGraphPeriod.MONTH)}>
          Month
        </DSMenuItem>
        <DSMenuItem onClick={() => handlePeriodSelect(OrderGraphPeriod.YEAR)}>
          Year
        </DSMenuItem>
      </DSMenu>
    </>
  );
};

export default PeriodSelector;
